import { css } from '@emotion/react';

export const traveler_picker_autocomplete = css`
  height: 3rem;
`;
